var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPowerbi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 18,
  height: 24,
  viewBox: "0 0 18 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 1.00125V22.9987C18 23.5516 17.5516 24 16.9987 24H10.7512C10.1983 24 9.75 23.5516 9.75 22.9987V1.00125C9.75 0.448275 10.1983 0 10.7512 0H16.9987C17.5518 0 18 0.448273 18 1.00125Z",
  fill: "url(#paint0_linear_103_12)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M13.125 7V24H4.875V7C4.875 6.44772 5.32272 6 5.875 6H12.125C12.6773 6 13.125 6.44772 13.125 7Z",
  fill: "url(#paint1_linear_103_12)"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 13V22.9999C0 23.5522 0.44772 24 1 24H8.25V13C8.25 12.4477 7.80228 12 7.24999 12H1C0.44772 12 0 12.4477 0 13Z",
  fill: "url(#paint2_linear_103_12)"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_103_12",
  x1: 8.375,
  y1: -2.3253e-7,
  x2: 18.7173,
  y2: 22.6072,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E6AD10"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#C87E0E"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_103_12",
  x1: 4.87433,
  y1: 6,
  x2: 13.5869,
  y2: 23.4251,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F6D751"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#E6AD10"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_103_12",
  x1: -0.000675117,
  y1: 12,
  x2: 4.79676,
  y2: 23.7252,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F9E589"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#F6D751"
})))));
export { SvgPowerbi as ReactComponent };
export default __webpack_public_path__ + "static/media/powerbi.c0b727dd.svg";